import { createContext } from 'react';

import {
  EventCategories,
  EventCategory,
  EventConfigurationItem,
  EventConfigurationItems,
} from '@totem/components/services/threats/configuration/types';

interface Context {
  loading: boolean;
  categories: EventCategories;
  items: EventConfigurationItems;

  editingCategory: EventCategory | null;
  categoryModalOpen: boolean;
  onAddCategory: () => void;
  onEditCategory: (category: EventCategory) => void;
  onCategoryModalClose: () => void;
  onSaveCategory: (category: EventCategory) => void;
  onDeleteCategory: (id: string) => void;

  editingItem: EventConfigurationItem | null;
  itemDrawerOpen: boolean;
  onAddItem: () => void;
  onEditItem: (item: EventConfigurationItem) => void;
  onItemDrawerClose: () => void;
  onSaveItem: (item: EventConfigurationItem) => void;
  onDeleteItem: (id: string) => void;
}

export default createContext<Context>({
  loading: false,
  categories: [],
  items: [],

  editingCategory: null,
  categoryModalOpen: false,
  onAddCategory: () => {},
  onEditCategory: () => {},
  onCategoryModalClose: () => {},
  onSaveCategory: () => {},
  onDeleteCategory: () => {},

  editingItem: null,
  itemDrawerOpen: false,
  onAddItem: () => {},
  onEditItem: () => {},
  onItemDrawerClose: () => {},
  onSaveItem: () => {},
  onDeleteItem: () => {},
});
